/**
 *
 */



class CategFactorable {

	constructor(resultData, or34, CategFactory) {
		this._or34 = or34;
		//

		this._resultData = resultData;

		if(arguments===3 && CategFactory instanceof CategFactorable) {

			this._nb3 = CategFactory.nb3;
			this._nb4 = CategFactory.nb4;
			this._resultMap = CategFactory.resultMap;

			this._nb = CategFactory.nb;

			this._nbSort = CategFactory.nbSort;
			//
			this._nbDef = CategFactory.nbDef;

			this._nb3DefDup = CategFactory.nb3DefDup;
			this._nb4DefDup = CategFactory.nb4DefDup;
			this._nbDefDup = CategFactory.nbDefDup;


		}else {

			this._nb3 = [];
			this._nb4 = [];
			this._resultMap = new Map();
			this._resultMap.set('nb3', this._nb3);
			this._resultMap.set('nb4', this._nb4);

			for(let i=0, n=this._resultData.length; i<n; i++) {
				this.pushNb3( this._resultData[i].nb3 );
				this.pushNb4( this._resultData[i].nb4 );
			};

			this._nb = this._nb3;
			if(this._or34 === 4) {   this._nb = this._nb4;   };



			this._nbSort = this._setNbSort(this._or34);
			//

			this._nbDef = this.makeNb34Def(this._or34);

			this._nb3DefDup = [];
			this._nb4DefDup = [];
			this._nbDefDup = this._nb3DefDup;
			if(this._or34 === 4) {   this._nbDefDup = this._nb4DefDup;   };
			this._setNb34DefDup();

		};

	};



	get or34() {   return this._or34;   };

	//

	get nb() {   return this._nb;   };

	get nb3() { return this._nb3; };
	pushNb3(val) {
		let arr = new Uint8Array(3);
		for(let i=0; i<3; i++) {   arr[i] = Number.parseInt(val.charAt(i));   };
		this._nb3.push(arr);
	};
	clearNb3() {  MyUtility.arrayClear(this._nb3);  };

	get nb4() { return this._nb4; };
	pushNb4(val) {
		let arr = new Uint8Array(4);
		for(let i=0; i<4; i++) {   arr[i] = Number.parseInt(val.charAt(i));   };
		this._nb4.push(arr);
	};

	get resultMap() { return this._resultMap; };

	//
	get nbDef() {   return this._nbDef;    };

	makeNb34Def(or34) {
		if(or34!==3 && or34!==4) {
			throw new Error('引数が不正です');
		};
		let arrOut = [];
		for(let i=0, n=Math.pow(10, or34); i<n; i++) {
			let arrInn = new Uint8Array(or34);
			for(let m=or34-1, j=m; j>=0; j--) {   arrInn[m-j] = (i%Math.pow(10, j+1))/Math.pow(10, j);   };
			arrOut.push(arrInn);
		};
		return arrOut;
	};

	//
	get nb3DefDup() {   return this._nb3DefDup;   };
	get nb4DefDup() {   return this._nb4DefDup;   };
	get nbDefDup() {   return this._nbDefDup;   };
	_setNb34DefDup() {
		for(let i=0; i<10; i++) {
			for(let j=i; j<10; j++) {
				for(let k=j; k<10; k++) {
					let arrInn = new Uint8Array(3);
					arrInn[0] = i;
					arrInn[1] = j;
					arrInn[2] = k;
					this._nb3DefDup.push(arrInn);
					for(let l=k; l<10; l++) {
						let arrInn2 = new Uint8Array(4);
						arrInn2[0] = i;
						arrInn2[1] = j;
						arrInn2[2] = k;
						arrInn2[3] = l;
						this._nb4DefDup.push(arrInn2);
					};
				};
			};
		};
	};


	//
	get nbSort() {   return this._nbSort;   };

	_setNbSort(or34) {
		return this.sortArrayUint8( this._resultMap.get('nb'+or34) );
	}



	//
	sarchCount(target, extra, count) {
		MyUtility.sarchCount(target, extra, count);
	};

	sortArrayUint8(sortArray) {
		let setArray = [];
		for(let i=0, n=sortArray.length; i<n; i++) {
			let sort = MyUtility.copySortUint8( sortArray[i] );
			setArray.push(sort);
		};
		return setArray;
	};

};






